/**
 * Sorts table data given rows and a column index.
 *
 * NOTE: THIS MODULE SHOULD ALWAYS FUNCTION WITHIN A WEB WORKER!
 *
 * @oaram  {object} e The postMessage event data
 *   @param  {array} e.dataToSort  An array of rows to sort
 *   @param  {number} e.sortByIndex The index int of the column to sort by
 *   @param  {number} e.sortByState 0 For ASC, 1 for DESC
 *
 * @return {undefined}
 */

onmessage = function (e) {
  if (e.data.type == "webpackOk") return;
  var postMessageTarget = e.data.XssSafeWorker ? window.top : this;
  var collection = e.data[0].dataToSort;
  var sortByIndex = e.data[0].sortByIndex;
  var sortByState = e.data[0].sortByState;

  // Check if it's a number. It can have a decimal so 100 and 10.00 both work.
  // It can also have a dash (otherwise -2 becomes 2).
  var numberMatcher = /[\d.-]+/g;

  /**
   * Returns true if there was NO spaces in any of the given items
   *
   * @param {string[]} items An array of strings to check for spaces on
   * @return {boolean} Returns true if NO spaces were found
   */
  var noSpaces = function (items) {
    return items.every(function (item) {
      return item.indexOf(" ") < 1;
    });
  };

  /**
   * Checks if ALL given items could be numbers. It validates against the regex
   * numberMatcher which checks if it's a digit. This only checks for numbers in
   * a string but does not actually try parsing it or checking NaN. For that,
   * use areNotNaN.
   *
   * @param {string[]} items An array of strings to match against numberMatcher
   * @return {boolean} Returns true if ALL given items could be numbers
   */
  var areNumbers = function (items) {
    return items.every(function (item) {
      return item.match(numberMatcher);
    });
  };

  /**
   * Returns true ALL given items are numbers that can be parsed and are not
   * NaN. This assumes you've at least checked areNumbers() first.
   *
   * @param {string[]} items An array of strings to check if would be NaN
   * @return {boolean} Returns true if ALL given items are numbers and not NaN
   */
  var areNotNaN = function (items) {
    return items.every(function (item) {
      return !isNaN(parseInt(item.match(numberMatcher).join("")));
    });
  };

  /*
   * Natural Sort algorithm for Javascript - Version 0.9 - Released under MIT license
   * Author: Jim Palmer (based on chunking idea from Dave Koelle)
   * Revisions: 0.8, 0.9 by BatchGeo
   */
  function naturalSort(a, b) {
    // If sortByIndex is -1 we'll default to sorting by id
    a = sortByIndex < 0 ? a.id : a.data[sortByIndex];
    b = sortByIndex < 0 ? b.id : b.data[sortByIndex];
    var re =
        /(^([+-]?(?:\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?)?$|^0x[\da-fA-F]+$|\d+)/g,
      sre = /^\s+|\s+$/g, // trim pre-post whitespace
      snre = /\s+/g, // normalize all whitespace to single ' ' character
      dre =
        /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
      i = function (s) {
        return (
          (naturalSort.insensitive && ("" + s).toLowerCase()) ||
          "" + s
        ).replace(sre, "");
      },
      // convert all to strings strip whitespace
      x = i(a) || "",
      y = i(b) || "",
      // chunk/tokenize
      xN = x
        .replace(re, "\0$1\0")
        .replace(/\0$/, "")
        .replace(/^\0/, "")
        .split("\0"),
      yN = y
        .replace(re, "\0$1\0")
        .replace(/\0$/, "")
        .replace(/^\0/, "")
        .split("\0"),
      // numeric, hex or date detection
      xD = parseInt(x.match(hre), 16) || (xN.length !== 1 && Date.parse(x)),
      yD =
        parseInt(y.match(hre), 16) ||
        (xD && y.match(dre) && Date.parse(y)) ||
        null,
      normChunk = function (s, l) {
        // normalize spaces; find floats not starting with '0', string or 0 if not defined (Clint Priest)
        return (
          ((!s.match(ore) || l == 1) && parseFloat(s)) ||
          s.replace(snre, " ").replace(sre, "") ||
          0
        );
      },
      oFxNcL,
      oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
      if (xD < yD) {
        return -1;
      } else if (xD > yD) {
        return 1;
      }
    }
    // natural sorting through split numeric strings and default strings
    for (
      var cLoc = 0, xNl = xN.length, yNl = yN.length, numS = Math.max(xNl, yNl);
      cLoc < numS;
      cLoc++
    ) {
      oFxNcL = normChunk(xN[cLoc] || "", xNl);
      oFyNcL = normChunk(yN[cLoc] || "", yNl);
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
        return isNaN(oFxNcL) ? 1 : -1;
      }
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
        oFxNcL += "";
        oFyNcL += "";
      }
      // This is added by us, BatchGeo.
      // By default, naturalSort will only sort by the first numbers when
      // numbers are string based. For example if these were your numbers:
      // `['10,000', '3,000,000']`
      // It would split out `10` and `3` so if you ordered by largest to
      // smallest it would do `['10,000', '3,000,000']` but really it should be
      // reversed. The code we added fixes this by checking if the given strings
      // don't have spaces (if there's spaces it could be an address or
      // something), that they're numbers, and that parsing them doesn't result
      // in NaN.
      else if (noSpaces([x, y]) && areNumbers([x, y]) && areNotNaN([x, y])) {
        oFxNcL = parseFloat(x.match(numberMatcher).join(""));
        oFyNcL = parseFloat(y.match(numberMatcher).join(""));
      }

      if (oFxNcL < oFyNcL) {
        return -1;
      }
      if (oFxNcL > oFyNcL) {
        return 1;
      }
    }
    return 0;
  }

  naturalSort.insensitive = true;

  // Sort our collection
  collection.sort(naturalSort);

  if (sortByState) {
    collection.reverse();
  }

  // Return the sort order as an object in order to retrieve sort position later
  var sortOrder = collection.reduce(function (acc, item, index) {
    acc[item.id] = index;
    return acc;
  }, {});

  postMessageTarget.postMessage({
    index: sortByIndex,
    state: sortByState,
    order: sortOrder,
  });
};
